import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function postProfitLoss(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postUserProfitLoss(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}pnl/master/user`, JSON.stringify(data), options);//+ "user/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postSportsRevenue(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "revenue/sport", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postRegisteredUser(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}register/count`, JSON.stringify(data), options);//+ "user/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postDeposit(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}deposit/count`, JSON.stringify(data), options);//+ "user/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postFirstDeposit(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}firstDeposit/count`, JSON.stringify(data), options);//+ "user/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postWithdrawal(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}withdraw/count`, JSON.stringify(data), options);//+ "user/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postAffPnL(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}affpnl/count`, JSON.stringify(data), options);//+ "user/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postAffDashboardData(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}depowithregpnl/count`, JSON.stringify(data), options);//+ "user/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};